// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transaction-table__table {
  width: 100%;
  border-collapse: collapse; }
  .transaction-table__table th,
  .transaction-table__table td {
    padding: 12px;
    text-align: center;
    font-size: 0.75rem; }
  .transaction-table__table th {
    background-color: #2b074d;
    font-weight: bold;
    color: #ffffff;
    padding-top: 20px;
    padding-bottom: 20px; }
  .transaction-table__table tr:nth-child(even) {
    background-color: #340c5a;
    color: #ffffff; }
  .transaction-table__table tr:hover {
    background-color: #757179;
    color: #ffffff;
    cursor: pointer; }

.transaction-table__controls {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  align-items: center;
  padding: 10px; }

.transaction-table__filter-button {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer; }
  .transaction-table__filter-button:hover {
    color: #e02574; }

.transaction-table__filter-container {
  position: relative;
  display: inline-block; }

.transaction-table__icon {
  width: 40px; }

.transaction-table__filter-dropdown {
  position: absolute;
  width: 160px;
  top: calc(100% + 10px);
  right: 0;
  z-index: 3;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px; }
  .transaction-table__filter-dropdown .transaction-table__filter-group {
    display: flex;
    flex-direction: column;
    gap: 5px; }
  .transaction-table__filter-dropdown .transaction-table__filter-label {
    width: 140px;
    font-weight: bold; }
  .transaction-table__filter-dropdown .transaction-table__filter-select {
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px; }

.transaction-details {
  background-color: #ffffff;
  color: #333333;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); }
  .transaction-details__item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 16px; }
    .transaction-details__item--verified {
      color: #60ffa8; }
    .transaction-details__item--false {
      color: #ff0000; }
  .transaction-details__label {
    flex-basis: 50%;
    color: #7d7d7d;
    font-weight: bold; }
  .transaction-details__value {
    flex-basis: 50%;
    font-weight: normal; }
  .transaction-details__content {
    padding: 10px; }

.status-cell {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-weight: bold; }

.status-cell.pending {
  color: #ffdb81; }

.status-cell.rejected {
  color: #ff0000; }

.status-cell.approved {
  color: #60ffa8; }

@media screen and (max-width: 768px) {
  .transaction-page__wrapper {
    width: 100%; }
  th {
    padding: 5px; }
  th:first-child {
    display: none; }
  td:first-child {
    display: none; }
  .table {
    font-size: 10px; } }
`, "",{"version":3,"sources":["webpack://./src/components/Table/style.scss","webpack://./src/styles/variables/_variables.scss"],"names":[],"mappings":"AAGE;EACE,WAAW;EACX,yBAAyB,EAAA;EAF1B;;IAMG,aAAa;IACb,kBAAkB;IAClB,kBAAkB,EAAA;EARrB;IAYG,yBCdwB;IDexB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,oBAAoB,EAAA;EAhBvB;IAoBG,yBCN6B;IDO7B,cCrBmB,EAAA;EDAtB;IA0BK,yBCxBuB;IDyBvB,cC3BiB;ID4BjB,eAAe,EAAA;;AAKrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe,EAAA;EARhB;IAWG,cCjCyB,EAAA;;ADqC7B;EACE,kBAAkB;EAClB,qBAAqB,EAAA;;AAGvB;EACE,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;EAXV;IAcG,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAhBX;IAoBG,YAAY;IACZ,iBAAiB,EAAA;EArBpB;IAyBG,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB,EAAA;;AAKxB;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,0CAA0C,EAAA;EAE1C;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe,EAAA;IAEf;MACE,cC3GqB,EAAA;ID8GvB;MACE,cC7GoB,EAAA;EDiHxB;IACE,eAAe;IACf,cAAc;IACd,iBAAiB,EAAA;EAGnB;IACE,eAAe;IACf,mBAAmB,EAAA;EAGrB;IACE,aAAa,EAAA;;AAIjB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,cC1I0B,EAAA;;AD6I5B;EACE,cC7IwB,EAAA;;ADgJ1B;EACE,cCnJyB,EAAA;;ADsJ3B;EACE;IACE,WAAW,EAAA;EAEb;IACE,YAAY,EAAA;EAEd;IAEE,aAAa,EAAA;EAEf;IACE,aAAa,EAAA;EAEf;IACE,eAAe,EAAA,EAChB","sourcesContent":["@import \"../../styles/variables/variables\";\n\n.transaction-table {\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n\n    th,\n    td {\n      padding: 12px;\n      text-align: center;\n      font-size: 0.75rem;\n    }\n\n    th {\n      background-color: $tokenBackgroundColor;\n      font-weight: bold;\n      color: #ffffff;\n      padding-top: 20px;\n      padding-bottom: 20px;\n    }\n\n    tr:nth-child(even) {\n      background-color: $tokenContainerBorderColor;\n      color: $tokenWhiteColor;\n    }\n\n    tr {\n      &:hover {\n        background-color: $tokenPlaceholderColor;\n        color: $tokenWhiteColor;\n        cursor: pointer;\n      }\n    }\n  }\n\n  &__controls {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 2rem;\n    align-items: center;\n    padding: 10px;\n  }\n\n  &__filter-button {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    background: none;\n    border: none;\n    cursor: pointer;\n\n    &:hover {\n      color: $tokenButtonHoverColor;\n    }\n  }\n\n  &__filter-container {\n    position: relative;\n    display: inline-block;\n  }\n\n  &__icon {\n    width: 40px;\n  }\n\n  &__filter-dropdown {\n    position: absolute;\n    width: 160px;\n    top: calc(100% + 10px);\n    right: 0;\n    z-index: 3;\n    background-color: #ffffff;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    .transaction-table__filter-group {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n\n    .transaction-table__filter-label {\n      width: 140px;\n      font-weight: bold;\n    }\n\n    .transaction-table__filter-select {\n      width: 100%;\n      padding: 5px;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n    }\n  }\n}\n\n.transaction-details {\n  background-color: #ffffff;\n  color: #333333;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\n\n  &__item {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    font-size: 16px;\n\n    &--verified {\n      color: $tokenVerifyStatus;\n    }\n\n    &--false {\n      color: $tokenErrorStatus;\n    }\n  }\n\n  &__label {\n    flex-basis: 50%;\n    color: #7d7d7d;\n    font-weight: bold;\n  }\n\n  &__value {\n    flex-basis: 50%;\n    font-weight: normal;\n  }\n\n  &__content {\n    padding: 10px;\n  }\n}\n\n.status-cell {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-weight: bold;\n}\n\n.status-cell.pending {\n  color: $tokenPendingStatus;\n}\n\n.status-cell.rejected {\n  color: $tokenErrorStatus;\n}\n\n.status-cell.approved {\n  color: $tokenVerifyStatus;\n}\n\n@media screen and (max-width: 768px) {\n  .transaction-page__wrapper{\n    width: 100%;\n  }\n  th{\n    padding: 5px;\n  }\n  th:first-child {\n  \n    display: none;\n  }\n  td:first-child {\n    display: none;\n  }\n  .table {\n    font-size: 10px;\n  }\n}\n","// Main Colors\n$tokenBackgroundColor: #2b074d;\n$tokenContainerBackgroundColor: rgba($tokenBackgroundColor, 0.85);\n$tokenWhiteColor: #ffffff;\n$tokenBlackColor: #000000;\n$tokenPlaceholderColor: #757179;\n\n// Status Colors\n$tokenVerifyStatus: #60ffa8;\n$tokenPendingStatus: #ffdb81;\n$tokenErrorStatus: #ff0000;\n\n// SHADOW\n$tokenContainerShadow: 0 0 14px 0 #ff2481;\n\n// BORDER\n$tokenContainerRadius: 20px;\n$tokenContainerBorderColor: #340c5a;\n\n// BUTTON\n$tokenButtonBorderColor: #e02574;\n$tokenButtonBackgroundColor: #ff2481;\n$tokenButtonHoverColor: #e02574;\n\n// COIN BACKGROUND\n$tokenCoinBackground: #ededed;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
